import { useEffect, useRef } from 'react';

export const usePrevious = <T>(value: T, initialValue: T | null = null): T | null => {
    const ref = useRef<T | null>(initialValue);

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
};
